module.exports = __webpack_public_path__ + "img/right.2f2141f3.png";